module.exports = __webpack_public_path__ + "img/delete_confirmed.c2380a64.svg";